import React from "react";

const CancellationRefund = () => (
  <div className="max-w-4xl mx-auto p-6 font-sans">
    <h1 className="text-3xl font-bold text-green-700 mb-6 text-center">Cancellation & Refund Policy</h1>
    
    <div className="space-y-6">
      <p className="text-gray-700 leading-relaxed">
        At <strong>JR Home Foods</strong>, we aim to offer flexible and customer-friendly cancellation and refund options. Please review the policy below for full details.
      </p>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">1. Subscription Cancellation</h2>
        <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
          <li>You may cancel your subscription at any time via the <strong>"My Plans"</strong> or <strong>"Profile"</strong> section of your account.</li>
          <li>Upon cancellation, all future undelivered meals will be marked as canceled and excluded from delivery.</li>
        </ul>
      </div>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">2. Refund Eligibility</h2>
        <p className="text-gray-700 mb-3">Refunds are issued based on:</p>
        <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
          <li>The number of <strong>undelivered meals remaining</strong> at the time of cancellation.</li>
          <li>The <strong>plan type</strong> and <strong>discounts used</strong> (if applicable).</li>
          <li>Refunds do <strong>not</strong> apply to meals already delivered or same-day cancellations.</li>
        </ul>
      </div>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">3. Refund Processing</h2>
        <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
          <li>Eligible refunds will be processed via the original payment method.</li>
          <li>Please allow <strong>5–7 working days</strong> for the refund to reflect in your account.</li>
          <li>Refund status updates will be communicated via email or SMS.</li>
        </ul>
      </div>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">4. Partial Cancellation or Plan Pausing</h2>
        <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
          <li>If you wish to pause your plan or skip specific days (e.g., travel, vacation), please contact our support at least <strong>24 hours in advance</strong>.</li>
          <li>Partial cancellations or modifications may be handled manually depending on your plan type.</li>
        </ul>
      </div>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">5. Non-Refundable Scenarios</h2>
        <p className="text-gray-700 mb-3">Refunds may <strong>not</strong> be applicable in the following cases:</p>
        <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
          <li>Missed deliveries due to user unavailability</li>
          <li>Incorrect delivery address or contact information</li>
          <li>Meals already prepared and dispatched</li>
        </ul>
      </div>

      <div className="bg-green-50 p-6 rounded-lg mt-8">
        <h3 className="text-lg font-bold text-green-700 mb-3">📞 Need Help with Cancellation?</h3>
        <p className="text-gray-700 mb-3">
          For cancellation requests or refund inquiries, please contact us:
        </p>
        <div className="space-y-1 text-gray-700">
          <p>📧 Email: help.jrhomefoods@gmail.com</p>
          <p>📞 Phone: 7893816225</p>
          <p className="text-sm text-gray-600 mt-2">
            <strong>Note:</strong> For immediate assistance, please include your order number and reason for cancellation.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default CancellationRefund; 